import React from 'react'
import './loading.css'
const Loading = () => {
    return (
        <div style={{textAlign:'center'}}>
            <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
        
    )
}

export default Loading
